(function () {
	angular.module('bizPartEngage').controller('modules.missionsList', missionListController);
	angular.module('bizPartEngage').directive('bizMission', bizMissionDirective);
	angular.module('bizPartEngage').directive('bizMissionRule', bizMissionRuleDirective);
	angular.module('bizPartEngage').directive('missionUser', missionUserDirective);
	angular.module('bizPartEngage').directive('bizMissionList', missionListDirective);

	bizMissionDirective.$inject = ["$interval", "bizCore"];
	bizMissionRuleDirective.$inject = ["$compile"];
	missionListDirective.$inject = ["bizCore"];

	function bizMissionDirective($interval, bizCoreProvider) {
		var directive = {
			restrict: 'E',
			transclude: true,
			scope: {
				mission: "="
			},
			templateUrl: bizCoreProvider.getView('bizMissionDirective', 'FrontEnd/Modules/Missions/views/directives/bizMission.html'),
			link: bizMissionLinkFunction,
			controller: bizMissionController,
			controllerAs: 'vm',
			bindToController: true
		};

		bizMissionController.$inject = ["$scope"];

		return directive;

		function bizMissionLinkFunction(scope, element) {
		}

		function bizMissionController($scope) {
			var vm = this;
			vm.GetNextRule = GetNextRule;
			vm.CalculateTimeStats = CalculateTimeStats;
			vm.CalculateCompletedPercent = CalculateCompletedPercent;

			function GetNextRule () {
				if (vm.NextRule)
					return vm.NextRule

				if (vm.mission != undefined && vm.mission.Rules != undefined) {
					for (var i = 0; i < vm.mission.Rules.length; i++) {
						if (~~vm.mission.Rules[i].PercentageComplete < 100) {
							rule = vm.mission.Rules[i];
							vm.NextRule = rule;
							break;
						}
					}
				}
				return vm.NextRule;
			};

			function CalculateTimeStats() {
				vm.Now = moment();
				vm.EndDate = moment(vm.mission.EndDate);
				vm.DaysLeft = vm.EndDate.diff(vm.Now, 'days');

				if (vm.DaysLeft <= 0)
					vm.DaysLeft = 0;

				vm.HoursLeft = vm.EndDate.diff(vm.Now.add(vm.DaysLeft, 'days'), 'hours');

				if (vm.HoursLeft <= 0)
					vm.HoursLeft = 0;

				vm.MinutesLeft = vm.EndDate.diff(vm.Now.add(vm.HoursLeft, 'hours'), 'minutes');

				if (vm.MinutesLeft <= 0)
					vm.MinutesLeft = 0;
			};

			function CalculateCompletedPercent() {
				vm.CompletedPercentage = 0;
				var totalPercentage = 0;
				var amountOfRules = 0;
				if (vm.mission.Rules != undefined) {
					for (var i = 0; i < vm.mission.Rules.length; i++) {
						totalPercentage += vm.mission.Rules[i].PercentageComplete;
						amountOfRules++;
					}

					if (totalPercentage > 0 && amountOfRules > 0)
						vm.CompletedPercentage = totalPercentage / amountOfRules;

					vm.CompletedPercentage = ~~vm.CompletedPercentage;
				}
			};

			$interval(vm.CalculateTimeStats, 10000);

			$scope.$watch(function () { return vm.mission; }, function () {
				vm.CalculateCompletedPercent();
				vm.CalculateTimeStats();
			});
		}
	}

	function bizMissionRuleDirective($compile) {
		var directive = {
			restrict: 'E',
			scope: {
				rule: "=",
				mission: "="
			},
			link: linkFunction
		};

		return directive;

		function linkFunction(scope, element) {
			scope.TemplateUrl = "";

			scope.KnobData =
            {
            	value: scope.rule.PercentageComplete,
            	options: {
					fgColor: scope.mission.Settings.SecondaryColor,
					bgColor: "#FFF",
            		inputColor: '#000000',
            		angleOffset: -125,
            		angleArc: 250,
            		readOnly: true,
            		width: 100,
            		displayInput: false
            	}
            };

			switch (scope.rule.Class) {
				default:
					scope.TemplateUrl = siteRootPath + "FrontEnd/Modules/Missions/views/directives/bizMissionRules/GenericTemplate.html";
					break;
			}

			angular.element(element).append($compile("<div ng-include=\"'" + scope.TemplateUrl + "'\"></div>")(scope));
		}
	}

	function missionUserDirective() {
		var directive = {
			restrict: "E",
			scope: {
				user: "="
			},
			templateUrl: siteRootPath + "FrontEnd/Modules/Missions/views/directives/bizMissionUser.html",
			link: linkFunction
		};

		return directive;

		function linkFunction(scope) {

		}
	}

	function missionListDirective(bizCoreProvider) {
		var directive = {
			restrict: "E",
			scope: {

			},
			templateUrl: bizCoreProvider.getView('base.modules.missions', 'FrontEnd/Modules/Missions/views/directives/bizMissionList.html'),
			controller: bizCoreProvider.getController('base.modules.missions', 'modules.missionsList'),
			controllerAs: 'vm',
			bindToController: true
		};

		return directive;
	}

	missionListController.$inject = ["modules.missions.service", "$stateParams", "$interval", "$translate", "MetadataService"];

	function missionListController(missionsService, $stateParams, $interval, $translate, MetadataService) {
		var vm = this;
	vm.Missions = [];
	
	vm.GetDate = GetDate;
	vm.GetMissions = GetMissions;
	vm.CalculateTimeStats = CalculateTimeStats;
	vm.CalculateCompletedPercent = CalculateCompletedPercent;
	vm.CalculateTimeStatsForAllMissions = CalculateTimeStatsForAllMissions;

	function GetDate (date) {
		return moment(date).format('YYYY-MM-DD');
	}

	function GetMissions() {
		missionsService.GetMissionsForUser().then(function (response) {
			vm.Missions = response.data || [];
			for (var i = 0; i < vm.Missions.length; i++) {
				vm.CalculateCompletedPercent(vm.Missions[i]);
				vm.CalculateTimeStats(vm.Missions[i]);
			}
			console.log(vm.Missions);
		});
	}

	function CalculateTimeStatsForAllMissions () {
		for (var i = 0; i < vm.Missions.length; i++) {
			vm.CalculateTimeStats(vm.Missions[i]);
		}
	}

	function CalculateCompletedPercent(mission) {
		mission.CompletedPercentage = 0;
		var totalPercentage = 0;
		var amountOfRules = 0;
		if (mission.Rules != undefined) {
			for (var i = 0; i < mission.Rules.length; i++) {
				totalPercentage += mission.Rules[i].PercentageComplete;
				amountOfRules++;
			}

			if (totalPercentage > 0 && amountOfRules > 0)
				mission.CompletedPercentage = totalPercentage / amountOfRules;

				mission.CompletedPercentage = ~~mission.CompletedPercentage;
			}
		};

		function CalculateTimeStats(mission) {
			var now = moment();
			var endDate = moment(mission.EndDate);
			mission.DaysLeft = endDate.diff(now, 'days');

			if (mission.DaysLeft <= 0)
				mission.DaysLeft = 0;

			mission.HoursLeft = endDate.diff(now.add(mission.DaysLeft, 'days'), 'hours');

			if (mission.HoursLeft <= 0)
				mission.HoursLeft = 0;

			mission.MinutesLeft = endDate.diff(now.add(mission.HoursLeft, 'hours'), 'minutes');

			if (mission.MinutesLeft <= 0)
				mission.MinutesLeft = 0;
		};

		$interval(vm.CalculateTimeStatsForAllMissions, 10000);

		angular.element(document).ready(function () {
			vm.GetMissions();

			$translate(['MISSIONS.META.TITLE', 'MISSIONS.META.DESCRIPTION']).then(function (translations) {
				MetadataService.setMetaTags({
					title: translations['MISSIONS.META.TITLE'],
					description: translations['MISSIONS.META.DESCRIPTION']
				})
			});
		});
	}
}());